import type { BudgetPhaseForm } from "./BudgetSelector";

/** Repeated on every bordered field shell (type, amount, phase amount). */
export const guidedBudgetFieldBorder = "#E6E6E6";
export const guidedBudgetFieldShadow = "0px 10px 15px #F7F7F7";
/** Headings, phase titles, primary button. */
export const guidedBudgetPrimaryColor = "#1A202C";

/** Phase row amount field ($ + value); spread on every phase `WhiteBgInput`. */
export const phaseBudgetInputProps = {
  border: "none",
  boxShadow: "none",
  bg: "transparent",
  px: 0,
  py: 0,
  /** Match MUI `TextField` / `DateTimePicker` `size="small"` input body (phase date pickers). */
  h: "40px",
  minH: "40px",
  lineHeight: "1.25",
  fontSize: "md",
  fontWeight: "medium",
  color: "gray.700",
  textAlign: "left" as const,
  _focusVisible: { boxShadow: "none", borderColor: "transparent" },
  _hover: { borderColor: "transparent" },
};

/**
 * Bordered shell for phase datetime range (`py={2.5}` + MUI small field) and phase amount column;
 * keep both columns on the same minimum height.
 */
export const phaseScheduledFieldShellMinH = "60px";

/** Touch-friendly width for the phase delete control; height follows row via `alignSelf="stretch"`. */
export const phaseRowDeleteIconMinW = "44px";

export const NO_SCHEDULED_SEGMENTS: BudgetPhaseForm[] = [];
